'use strict';

function isAcceptableFormat(blob) {
    return new Promise((resolve) => {
        if (blob) {
            const filereader = new FileReader()
            filereader.onloadend = function(evt) {
                if (evt.target.readyState === FileReader.DONE) {
                    const uint = new Uint8Array(evt.target.result)
                    let bytes = []
                    uint.forEach((byte) => {
                        bytes.push(byte.toString(16))
                    })
                    const hex = bytes.join('').toUpperCase()
                    if (getMimetype(hex) === 'Unknown filetype') {
                        resolve(false);
                    } else {
                        resolve(true);
                    }
                }
            }
            const newBlob = blob.slice(0, 4);
            filereader.readAsArrayBuffer(newBlob);
        } else {
            resolve(false);
        }
    });
}

const getMimetype = (signature) => {
    switch (signature) {
        case '89504E47':
            return 'image/png'
        case '47494638':
            return 'image/gif'
        case 'FFD8FFDB':
        case 'FFD8FFE0':
        case 'FFD8FFE1':
        case 'FFD8FFE8':
            return 'image/jpeg'
        case '424DC63E':
            return 'image/bmp'
        default:
            return 'Unknown filetype'
    }
}

function blobToBase64(blob, callback) {
    var reader = new FileReader();
    reader.onload = function() {
        var base64 = reader.result;
        callback(base64);
    };
    reader.readAsDataURL(blob); 
}

function getOrientationEXIF(blob, callback) {
      var fileReader = new FileReader();
      fileReader.readAsArrayBuffer(blob);
      fileReader.onloadend = function () {
          var scanner = new DataView(fileReader.result);
          var idx = 0;
          var value = 1; // Non-rotated is the default
          if (fileReader.result.length < 2 || scanner.getUint16(idx) != 0xFFD8) {
              if (callback) {
                  callback(value);
              }
              return;
          }
          idx += 2;
          var maxBytes = scanner.byteLength;
          var littleEndian = false;
          while (idx < maxBytes - 2) {
              var uint16 = scanner.getUint16(idx, littleEndian);
              idx += 2;
              switch (uint16) {
                  case 0xFFE1: // Start of EXIF
                      var endianNess = scanner.getUint16(idx + 8);
                      // II (0x4949) Indicates Intel format - Little Endian
                      // MM (0x4D4D) Indicates Motorola format - Big Endian
                      if (endianNess === 0x4949) {
                          littleEndian = true;
                      }
                      var exifLength = scanner.getUint16(idx, littleEndian);
                      maxBytes = exifLength - idx;
                      idx += 2;
                      break;
                  case 0x0112: // Orientation tag
                      // Read the value, its 6 bytes further out
                      value = scanner.getUint16(idx + 6, littleEndian);
                      maxBytes = 0; // Stop scanning
                      break;
              }
          }
          // return result - orientation from EXIF data
          if (callback) {
              callback(value);
          }
      }
}

async function prepareImage(input, maxResolution, quality, callback) {
    // check file format
    let isAllowedFormat = await isAcceptableFormat(input);
    if (!isAllowedFormat) {
        callback(null);
    }
    // Extract EXIF orientation data
    getOrientationEXIF(input, (value) => {
        blobToBase64(input, (base64) => {
            var image = document.createElement('img');
            image.src = base64;
            image.onload = () => {
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');

                // resize image
                if ((image.naturalWidth > maxResolution) || (image.naturalHeight > maxResolution)) {
                    // horizontal orientation
                    if (image.naturalWidth > image.naturalHeight) {
                        // calc scale factor
                        const scaleFactor = maxResolution / image.naturalWidth;
                        let nHeight = image.naturalHeight * scaleFactor;
                        canvas.width = maxResolution;
                        canvas.height = nHeight;
                    }
                    // vertical orientation
                    if (image.naturalHeight > image.naturalWidth) {
                        const scaleFactor = maxResolution / image.naturalHeight;
                        let nWidth = image.naturalWidth * scaleFactor;
                        canvas.width = nWidth;
                        canvas.height = maxResolution;
                    }
                    // square
                    if (image.naturalHeight === image.naturalWidth) {
                        const scaleFactor = maxResolution / image.naturalHeight;
                        let nWidth = image.naturalWidth * scaleFactor;
                        canvas.width = nWidth;
                        canvas.height = canvas.width;
                    }
                } else {
                    // save original width and height
                    canvas.width = image.naturalWidth;
                    canvas.height = image.naturalHeight;
                }

                console.log('Old resolution: ' + image.naturalWidth + 'x' + image.naturalHeight);
                console.log('New resolution: ' + canvas.width + 'x' + canvas.height);

                // change black background to white if image have transparent layers
                var pixels = ctx.getImageData(0, 0, canvas.width, canvas.height);
                // iterate through pixel data (1 pixels consists of 4 ints in the array)
                for(var i = 0, len = pixels.data.length; i < len; i += 4) {
                    // change non-opaque pixels to white
                    if (pixels.data[i+3] < 255) {
                        pixels.data[i] = 255;
                        pixels.data[i+1] = 255;
                        pixels.data[i+2] = 255;
                        pixels.data[i+3] = 255;
                    }
                }
                ctx.putImageData(pixels, 0, 0);

                // if image does not have EXIF or have default orientation
                if ((value !== 3) && (value !== 6) && (value !== 8)) {
                    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
                    // compress according imageCompressLevel
                    ctx.canvas.toBlob((blob) => {
                        blobToBase64(blob, (base64) => {
                            blob.lastModified = new Date();
                            blob.name = 'my-image.jpg';
                            blob.__proto__ = File.prototype;
                            callback(blob, base64);
                        });
                    }, 'image/jpeg', quality);
                } else { // if orientation not default -> physically rotate image on canvas
                    let height = canvas.height;
                    let width = canvas.width;
                    switch (value) {
                        // 180deg
                        case 3:
                        ctx.translate(canvas.width / 2, canvas.height / 2);
                        ctx.rotate((Math.PI / 180) * 180);
                        ctx.drawImage(image, -width / 2, -height / 2, width, height);
                        break;
                        // 90deg
                        case 6:
                        // rotate canvas
                        canvas.width = height;
                        canvas.height = width;
                        // translate to center-canvas the origin [0,0] is now center-canvas
                        ctx.translate(canvas.width / 2, canvas.height / 2);
                        // roate the canvas Math.PI / 180 *deg
                        ctx.rotate((Math.PI / 180) * 90);
                        // draw image from top-left offset the draw by 1/2 width & height
                        ctx.drawImage(image, -width / 2, -height / 2, width, height);
                        break;
                        // 270deg
                        case 8:
                        canvas.width = height;
                        canvas.height = width;
                        ctx.translate(canvas.width / 2, canvas.height / 2);
                        ctx.rotate((Math.PI / 180) * 270);
                        ctx.drawImage(image, -width / 2, -height / 2, width, height);
                        break;
                    }
                    // compress according imageCompressLevel
                    ctx.canvas.toBlob((blob) => {
                        blobToBase64(blob, (base64) => {
                            blob.lastModified = new Date();
                            blob.name = 'my-image.jpg';
                            blob.__proto__ = File.prototype;
                            callback(blob, base64);
                        });
                    }, 'image/jpeg', quality);
                }   
            }
        });
    });
}

export default prepareImage;